import { Link } from 'react-router-dom';
import { rankingShows } from '@/mocks/tv-shows';
import TvShowCard from './TvShowCard';

export default function RankingSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            <i className="ri-fire-line text-accent-500 mr-2"></i>
            热播排行榜
          </h2>
          <p className="text-sm text-foreground-500 mt-1">全网评分最高、热度最高的剧集都在这里</p>
        </div>
        <Link
          to="/category/all"
          className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
        >
          查看完整榜单 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
        <div className="lg:col-span-3 grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5">
          {rankingShows.slice(0, 6).map((show) => (
            <TvShowCard key={show.id} show={show} />
          ))}
        </div>

        <div className="lg:col-span-2 bg-background-50 rounded-xl p-5 border border-background-200/70">
          <h3 className="font-heading text-lg font-bold text-foreground-900 mb-4 flex items-center gap-2">
            <i className="ri-trophy-line text-accent-500"></i>
            评分 TOP 10
          </h3>
          <div className="flex flex-col gap-0.5">
            {rankingShows.map((show, idx) => (
              <TvShowCard key={show.id} show={show} variant="ranking" rank={idx + 1} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}